
export default (app: any) => {
  //select下拉加载数据
  app.directive('loadmore', {
    bind(el: any, binding: any) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM: any = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
      SELECTWRAP_DOM.addEventListener('scroll', function () {
        // @ts-ignore
        let that = this as any
        const CONDITION = ((that.scrollHeight - that.scrollTop) <= that.clientHeight)
        if (CONDITION) {
          binding.value()
        }
      })
    }
  })
  const is_webp = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') >=0
  app.directive('webp', (el: any) => {
    if(!is_webp) return 

      const cvWebpFn = ($el: any) => {
        const url = $el.src
        let reg = /^(https?:\/\/image.kilimall.com|https?:\/\/image.kilitest.com)(.+\/)+.+(\.(png|jpg|jpeg|svg|psd|bmp|tif))$/i
        // 符合域名、图片格式
        if (!url.toString().includes('.webp') && reg.test(url)) {
          $el.src =  url + '.webp'
        } 
      }
      if(el.nodeName === 'IMG') {
        cvWebpFn(el)
      } else { // 兼容第三方UI的Img组件
        const imgList = el.querySelectorAll('img')
        imgList.forEach((itemEl: any) => {
          if(itemEl.nodeName === 'IMG') {
            cvWebpFn(itemEl)
          }
        });
      }
      
  })
}
